type GqlExchangeCacheClearer = () => void;

let gqlExchangeCacheClearer: GqlExchangeCacheClearer | null = null;

export function registerGqlExchangeCacheClearer(
  clearer: GqlExchangeCacheClearer
): void {
  gqlExchangeCacheClearer = clearer;
}

/** Clears module-level GraphQL token exchange caches (e.g. on logout). */
export function clearGqlExchangeCache(): void {
  gqlExchangeCacheClearer?.();
}
